module.exports = __webpack_public_path__ + "static/bigscreen1-67461e3e94b47c0272d77905a3610da7.jpg";